export default __webpack_public_path__ + "static/media/more.daf43cd8.svg";